import { webCrypto } from '#web-crypto';
import { digestOutput } from './constants';
export const pbkdf2Digest = (password, salt, iterations, hashFunction) => webCrypto.subtle.deriveBits({
    name: 'PBKDF2',
    salt: salt,
    iterations: iterations,
    hash: hashFunction,
}, password, digestOutput[hashFunction]);
export const pbkdf2DeriveAesKey = (password, salt, iterations, hash) => webCrypto.subtle.deriveKey({
    name: 'PBKDF2',
    salt,
    iterations,
    hash,
}, password, { name: 'AES-KW', length: 256 }, false, ['wrapKey', 'unwrapKey']);
